import { type ComponentProps } from "react";
import {
  FormProvider,
  type FieldValues,
  type UseFormReturn,
} from "react-hook-form";

import { cn } from "@/helpers/className";

interface FormProps<
  TFieldValues extends FieldValues = FieldValues,
  TContext = any,
  TTransformedValues extends FieldValues | undefined = undefined,
> extends Omit<ComponentProps<"form">, "onSubmit"> {
  form: UseFormReturn<TFieldValues, TContext, TTransformedValues>;
  onSubmit?: Parameters<
    UseFormReturn<TFieldValues, TContext, TTransformedValues>["handleSubmit"]
  >[0];
}

const Form = <
  TFieldValues extends FieldValues = FieldValues,
  TContext = any,
  TTransformedValues extends FieldValues | undefined = undefined,
>({
  form,
  onSubmit,
  children,
  ...props
}: FormProps<TFieldValues, TContext, TTransformedValues>) => {
  return (
    <FormProvider {...form}>
      <form
        onSubmit={onSubmit ? form.handleSubmit(onSubmit) : undefined}
        {...props}
        className={cn("form", props.className)}
      >
        {children}
      </form>
    </FormProvider>
  );
};

export default Form;
